import React from 'react';
import { isEmpty } from 'lodash-es';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import { AddressIcon, BloodgroupIcon, CakeIcon, ChevronDownIcon, EmailIcon, OfficeIcon, PhoneIcon } from '../assets/icons';
import { resolveContactImageSrc } from '../utils/image';

import styles from './ContactCardAccordion.module.css';
import ProfileImage from './ProfileImage';

const ContactCardAccordion = ({ contact, expanded, handleChange }) => {
  const photoPath = resolveContactImageSrc(contact.photoFile);

  return (
    <Accordion className={styles.accordionRoot} expanded={expanded === contact.id} onChange={handleChange(contact.id)}>
      <AccordionSummary
        expandIcon={<ChevronDownIcon width={24} height={24} color="#393939" />}
        classes={{
          content: styles.accordionContent
        }}
      >
        <ProfileImage photo={photoPath} />
        <div className={styles.summaryTextWrapper}>
          <div className={styles.name}>{contact.name}</div>
          <div className={styles.relation}>{contact.relation}</div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={styles.accordionDetails}>
        {!isEmpty(contact.occupation) && (
          <div className={styles.detailWrapper}>
            <OfficeIcon className={styles.detailIcon} /><div className={styles.detailText}>{contact.occupation}</div>
          </div>
        )}
        {Number(contact.mobile) > 0 && (
          <a href={`tel:${contact.mobile}`} className={styles.detailWrapper}>
            <PhoneIcon className={styles.detailIcon} /><div className={styles.detailText}>{contact.mobile}</div>
          </a>
        )}
        {Number(contact.alternateNumber) > 0 && (
          <a href={`tel:${contact.alternateNumber}`} className={styles.detailWrapper}>
            <PhoneIcon className={styles.detailIcon} /><div className={styles.detailText}>{contact.alternateNumber}</div>
          </a>
        )}
        {!isEmpty(contact.email) && (
          <a href={`mailto:${contact.email}`} className={styles.detailWrapper}>
            <EmailIcon className={styles.detailIcon} /><div className={styles.detailText}>{contact.email}</div>
          </a>
        )}
        {!isEmpty(contact.currentAddress) && (
          <div className={styles.detailWrapper}>
            <AddressIcon className={styles.detailIcon} /><div className={styles.detailText}>{contact.currentAddress}</div>
          </div>
        )}
        <div className={styles.flexWrapper}>
          {!isEmpty(contact.birthDate) && (
            <div className={styles.detailWrapper}>
              <CakeIcon className={styles.detailIcon} /><div className={styles.detailText}>{contact.birthDate}</div>
            </div>
          )}
          {!isEmpty(contact.bloodGroup) && (
            <div className={styles.detailWrapper}>
              <BloodgroupIcon className={styles.detailIcon} /><div className={styles.detailText}>{contact.bloodGroup}</div>
            </div>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  )
};

export default ContactCardAccordion;
